// External imports
import { useState, useEffect } from "react";
import { MapContainer as MapCont } from "react-leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import L from "leaflet";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

// Internal imports
import Alert from "components/molecules/Alert/Alert";
import Column from "components/atoms/Column/Column";
import CardNew from "components/molecules/Card/CardNew";
import TrackingMap from "./TrackingMap";
import Schedule from "./Schedule";

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
function MapContainer({ data, shipmentRoute, isLoading }) {
  const [showMap, setShowMap] = useState(true);
  const { schedule } = data || {};

  useEffect(() => {
    if (schedule?.schedule_stops?.length > 0) {
      const pickupDeliveryCoordinates = schedule.schedule_stops.filter(
        (cordinate) =>
          (cordinate.pickup_latitude && cordinate.pickup_longitude) ||
          (cordinate.delivery_latitude && cordinate.delivery_longitude),
      );
      if (pickupDeliveryCoordinates?.length > 1) {
        setShowMap(true);
      }
    }
  }, [schedule]);

  if (isLoading)
    return (
      <Column style={{ borderRadius: "14px !important" }}>
        <CardNew isLoading={isLoading} loadingSkeletonRowCount={2} />
      </Column>
    );
  return (
    <CardNew className="p-0">
      <CardNew.Body>
        {Object.keys(data)?.length ? (
          <div className="d-flex flex-xs-wrap">
            <div className="d-flex position-relative w-100 mb-xs-3" style={{ height: "fit-content" }}>
              <Schedule
                showMap={showMap}
                schedule={data?.schedule?.schedule_stops}
                isDelivered={data?.organization?.shipment_status === "Delivered"}
                bookedDate={data?.schedule?.booking_date}
              />
            </div>
            {showMap && (
              <div className="w-100">
                <MapCont
                  center={[62.377956, 4.89707]}
                  zoom={2}
                  style={{ height: "100%", zIndex: 1, borderRadius: "14px" }}
                  scrollWheelZoom
                  gestureHandling
                >
                  <TrackingMap data={data} shipmentRoute={shipmentRoute} />
                </MapCont>
              </div>
            )}
          </div>
        ) : (
          <Alert className="mt-3 mb-1 ml-4" variant="warning">
            <FormattedMessage id="recent.noDetailsFound" defaultMessage="No details found" />
          </Alert>
        )}
      </CardNew.Body>
    </CardNew>
  );
}

MapContainer.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  shipmentRoute: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool.isRequired,
};

MapContainer.defaultProps = {
  shipmentRoute: null,
};

export default MapContainer;
